import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { InfoOutlined as InfoIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const FIELD_HEIGHT = 36;

// eslint-disable-next-line react/prop-types
const ClientStoresStep = ({
  clientId, onClientChange,
  clients, loadingClients,
  stores, loadingStores,
  needsStoresPicker,
  storeIds, onStoreToggle, onToggleAllStores,
  isClientAdminCaller,
}) => {
  const { t } = useTranslation('users');

  return (
    <Stack spacing={2}>
      {!isClientAdminCaller && (
        <Box>
          <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.06em', mb: 1 }}>
            {t('invite.fields.client')}
          </Typography>
          {loadingClients ? <CircularProgress size={20} /> : (
            <Select size="small" value={clientId} onChange={(e) => onClientChange(e.target.value)} displayEmpty fullWidth sx={{ height: FIELD_HEIGHT, fontSize: 13 }}>
              <MenuItem value="" disabled sx={{ fontSize: 13 }}>{t('invite.placeholders.selectClient')}</MenuItem>
              {clients.map((c) => <MenuItem key={c.id} value={c.id} sx={{ fontSize: 13 }}>{c.name}</MenuItem>)}
            </Select>
          )}
        </Box>
      )}
      {clientId && (
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
              <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                {t('invite.fields.stores')}
              </Typography>
              {!needsStoresPicker && (
                <Tooltip title={t('invite.hints.clientAdminAllStoresInfo')}>
                  <InfoIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
                </Tooltip>
              )}
            </Box>
            {needsStoresPicker && stores.length > 0 && (
              <Typography
                onClick={onToggleAllStores}
                sx={{ fontSize: 11.5, color: 'primary.main', fontWeight: 600, cursor: 'pointer' }}
              >
                {storeIds.length === 0 ? t('invite.selectAllStores') : t('invite.deselectAllStores')}
              </Typography>
            )}
          </Box>
          {loadingStores ? <CircularProgress size={20} /> : (
            <Box sx={{ maxHeight: 180, overflowY: 'auto', border: '1px solid', borderColor: 'divider', borderRadius: '8px', px: 1, ...(needsStoresPicker ? {} : { bgcolor: '#f7f7f8', opacity: 0.65 }) }}>
              {stores.length === 0 ? (
                <Typography sx={{ fontSize: 13, color: 'text.disabled', py: 1.5, textAlign: 'center' }}>{t('invite.noStoresAvailable')}</Typography>
              ) : (
                stores.map((s) => (
                  <FormControlLabel
                    key={s.id}
                    disabled={!needsStoresPicker}
                    control={<Checkbox size="small" checked={needsStoresPicker ? storeIds.includes(s.id) : true} onChange={() => onStoreToggle(s.id)} />}
                    label={<ListItemText primary={s.name} secondary={s.city} primaryTypographyProps={{ fontSize: 13, color: needsStoresPicker ? 'text.primary' : 'text.disabled' }} secondaryTypographyProps={{ fontSize: 11 }} />}
                    sx={{ display: 'flex', width: '100%', m: 0, py: 0.25 }}
                  />
                ))
              )}
            </Box>
          )}
        </Box>
      )}
    </Stack>
  );
};

export default ClientStoresStep;
